export const lineStanzaPool = [
    {
      form: "Quatrain",
      lines: 4,
      distractors: ["3", "6", "8"]
    },
    {
      form: "Sonnet",
      lines: 14,
      distractors: ["12", "8", "6"]
    },
    {
      form: "Haiku",
      lines: 3,
      distractors: ["4", "5", "7"]
    }
  ];
  